import React from 'react';

interface SectionTitleProps {
    children: React.ReactNode;
    icon?: React.ComponentType<{ className?: string; style?: React.CSSProperties }>;
    /** Cor do ícone e do traço — pills da home (`accentHexForFormato`). */
    accentColor?: string;
}

const DEFAULT_ACCENT = '#ff6b35';

export default function SectionTitle({ children, icon: Icon, accentColor }: SectionTitleProps) {
    const color = accentColor ?? DEFAULT_ACCENT;
    return (
        <div className="flex items-center gap-3 mb-6">
            {Icon ? <Icon className="w-6 h-6" style={{ color }} /> : null}
            <h2 className="text-2xl font-bold text-white relative inline-block">
                {children}
                <span className="absolute -bottom-2 left-0 w-1/3 h-1 rounded-full" style={{ backgroundColor: color }} />
            </h2>
        </div>
    );
}
